/** Row click on a Compliance board: opens the breached Service Line, where its task and schedule are fixed. */
import { inject, Injector } from '@angular/core';
import { ActivityEntityName, ComplianceFlagBoardRow } from '@jms/model';
import { EntityInspectors } from '@workbuddy/ui/v2/blocks/entity.inspector';

/**
 * The line, not the Visit: the flag's Visit link names an occurrence identity, which may never have been
 * stored, while the line always exists and owns the task whose deadline passed. Runs in the board's injection context.
 */
export async function openComplianceFlagLine(row: ComplianceFlagBoardRow): Promise<void> {

  const lineId = row?.serviceLine?._id;
  if (!lineId) return;

  await inject(Injector).get(EntityInspectors).open({
    operation: 'edit',
    entity: ActivityEntityName.ServiceLine,
    id: lineId,
  });
}
